export const SET_PRODUCTS = "PRODUCTS/SET_PRODUCTS"
export const SET_QUANTITY_FRACTIONAL = "PRODUCTS/SET_QUANTITY_FRACTIONAL"
export const SET_MINIMUM_QUANTITY_FRACTIONAL = "PRODUCTS/SET_MINIMUM_QUANTITY_FRACTIONAL"
export const SET_ITEM = "PRODUCTS/SET_ITEM"
export const SET_ITEM_WISH = "PRODUCTS/SET_ITEM_WISH"
export const SET_RESET_VAL_MODAL = "PRODUCTS/SET_RESET_VAL_MODAL"
export const SET_MINIMUM_QUANTITY = "PRODUCTS/SET_MINIMUM_QUANTITY"
export const SET_NUMBER_OF_BOXES_SELECTED = "PRODUCTS/SET_NUMBER_OF_BOXES_SELECTED"
export const SET_CONVERSION_UNIT_WHEN_SELLING_WITH_CLOSED_BOX = "PRODUCTS/SET_CONVERSION_UNIT_WHEN_SELLING_WITH_CLOSED_BOX"
export const SET_QUANTITY_PRODUCT_ITEMS_GROUP = "PRODUCTS/SET_QUANTITY_PRODUCT_ITEMS_GROUP"
export const SET_PRODUCT_PRICE_TO_BKP_DISCOUNT_CLOSED_BOX = "PRODUCTS/SET_PRODUCT_PRICE_TO_BKP_DISCOUNT_CLOSED_BOX"
export const SET_PRODUCT_PRO_PRICE_SITE_BKP_DISCOUNT_CLOSED_BOX = "PRODUCTS/SET_PRODUCT_PRO_PRICE_SITE_BKP_DISCOUNT_CLOSED_BOX"
export const SET_SETTINGS = "PRODUCTS/SET_SETTINGS"
export const SET_FLAVORS = "PRODUCTS/SET_FLAVORS"

export const SET_QUANTITY = "PRODUCTS/SET_QUANTITY"
export const SET_AVAILABILITY = "PRODUCTS/SET_AVAILABILITY"
export const SET_RESET_ITEMS_GRID = "PRODUCTS/SET_RESET_ITEMS_GRID"

export const SET_PRICE_PRODUCT = "PRODUCTS/SET_PRICE_PRODUCT"

// PRODUCT
export const SET_RESET_PRODUCT = "PRODUCTS/SET_RESET_PRODUCT"
export const SET_BKP_PRODUCT = "PRODUCTS/SET_BKP_PRODUCT"

// ADDITIONAL ITEMS
export const SET_ADDITIONAL_ITEMS = "PRODUCTS/SET_ADDITIONAL_ITEMS"
export const SET_ADDITIONAL_ITEMS_SELECTED = "PRODUCTS/SET_ADDITIONAL_ITEMS_SELECTED"
export const RESET_ADDITIONAL_ITEMS = "PRODUCTS/RESET_ADDITIONAL_ITEMS"

// VARIATIONS
export const SET_VARIATIONS = "PRODUCTS/SET_VARIATIONS"
export const RESET_ACTIVE_VARIATIONS = "PRODUCTS/RESET_ACTIVE_VARIATIONS"
export const SET_ITEM_BY_VARIATION = "PRODUCTS/SET_ITEM_BY_VARIATION"
